import { useInfrastructureSectionContent } from './useInfrastructureSectionContent';
import { parseInfrastructureProtocolsContent } from '../utils/infrastructureContent';

export const useInfrastructureProtocolsContent = () =>
  useInfrastructureSectionContent(parseInfrastructureProtocolsContent);
